// extracted by mini-css-extract-plugin
export default {"departments":"_H-z","departmentHeading":"aI-z","departmentSection":"bI-z","departmentName":"cI-z","departmentLink":"dI-z","expandIcon":"eI-z"};